export interface Batch {
    id: string,
    businessKey: string;
    starts: number;
    count: number;
}


export enum TokenStatus {
    ACTIVE = 'ACTIVE',
    USED = 'USED',
    VALID = 'VALID',
    INVALID = 'INVALID',
    USED_BLOCKED = 'USED_BLOCKED',
    CAPTCHA_FAILED = 'CAPTCHA_FAILED',
};
